import script from "./LinkAccountsShoutPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkAccountsShoutPanel.vue?vue&type=script&setup=true&lang=ts"

import "./LinkAccountsShoutPanel.vue?vue&type=style&index=0&id=b79b8608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b79b8608"]])

export default __exports__